<template>
  <div class="table content-chart">
    <div class="content-title" style="display:inline-block;">综合概览表格（{{totalCount}}人）</div>
    <span style='color: #2CB9B8;cursor: pointer; float:right;font-weight: normal' @click="exportDetail">导出</span>
    <el-table :data="tableData"  border :row-class-name="tableRowClassName"  v-loading="loading">
      <template v-for="item in detailConfig">
        <el-table-column
          :prop="item.prop"
          :label="item.label"
          :key="item.prop"
          :width="item.width||''"
          :sortable="item.sortable"
          :fixed="item.fixed"
          :min-width="item.min_width||''"
          :render-header="renderHeader"
        >
          <template slot-scope="scope">
            <div v-if="item.prop=='operator_name'">
              <span @click='getLastProducLine(scope.row.operator_name)' style="color:#1890ff;cursor: pointer;font-weight: normal;">{{scope.row.operator_name}}</span>
              <!-- <router-link :to="{path: '/personnel-portrait/personnel-portrait-details', query: {'operator': scope.row.operator, 'product_line': scope.row.product_line }}">{{scope.row.operator_name}}</router-link> -->
            </div>
            <div v-else>{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <template>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
    </template>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { downloadBlobFile } from '@/utils/download'
import {
  detailConfigs,
  clScoreContent,
  xlScoreContent,
  zlScoreContent,
  hsScoreContent,
  clValueContent,
  xlValueContent,
  zlValueContent,
  hsValueContent,
  scoreContent
  //  radarExtend
} from '../overviewConfig'
import { getGaiLanTable, gaiLanExport, getProductLine } from '@/api/personnelPortraitOverview'
const { mapState } = createNamespacedHelpers(
  'personnelPortraitOverview'
)
const mixin = {
  computed: {
    ...mapState({
      tabName: state => state.activeTabName,
      formData: state => state.formData,
      inquireNum: state => state.inquireNum
    })
  },
  methods: {
  }
}
export default {
  data () {
    return {
      tableData: [],
      totalCount: 0,
      detailConfig: detailConfigs['gailanzuoye'],
      currentPage: 1, // 第几页
      pageSize: 10, // 每页有多少
      operator_type: 'zhizuo',
      loading: false
    }
  },
  mixins: [mixin],
  props: ['isIframe'],
  computed: {
    // 接口发送时传递的参数
    queryParams: function () {
      return {
        operator_type: this.operator_type,
        start_time: this.formData.start_time,
        end_time: this.formData.end_time,
        production_line: this.formData.production_line,
        outsourcer: this.formData.outsourcer,
        task_type: this.formData.task_type,
        task_label: this.formData.task_label,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        platform: this.formData.platform
      }
    }
  },
  mounted () {
    this.setDetailConfig(this.tabName)
  },
  methods: {
    renderHeader (h, { column, $index }) {
      if (column.property === 'cl_score') { // 作业产量得分
        return this.renderHeaderItem(column, clScoreContent)
      }
      if (column.property === 'xl_score') { // 制作效率得分
        return this.renderHeaderItem(column, xlScoreContent)
      }
      if (column.property === 'zl_score') { // 验收一次缺陷率得分
        return this.renderHeaderItem(column, zlScoreContent)
      }
      if (column.property === 'hs_score') { // 有效时长得分
        return this.renderHeaderItem(column, hsScoreContent)
      }
      // if (column.property === 'cl_value') { // 作业产量
      //   return this.renderHeaderItem(column, clValueContent)
      // }
      // if (column.property === 'xl_value') { // 制作效率
      //   return this.renderHeaderItem(column, xlValueContent)
      // }
      // if (column.property === 'zl_value') { // 验收一次缺陷率
      //   return this.renderHeaderItem(column, zlValueContent)
      // }
      // if (column.property === 'hs_value') { // 有效时长
      //   return this.renderHeaderItem(column, hsValueContent)
      // }
      if (column.property === 'score') { // 综合得分
        return this.renderHeaderItem(column, scoreContent)
      }
      return column.label
    },
    renderHeaderItem (column, con) {
      return (
        <span style="line-height: 0; color: #909399">
          {column.label}
          <el-tooltip placement="top">
            <div slot="content" inner>
              <div domPropsInnerHTML={con}></div>
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
      )
    },
    // 获取表格数据
    async getTableData () {
      let flag = this.requiredParams()
      if (flag) {
        this.loading = true
        let res = await getGaiLanTable(this.queryParams)
        // console.log(res, '概览表格')
        if (res) {
          this.loading = false
          let { totalCount, data: tableData } = res
          for (let i = 0; i < tableData.length; i++) {
            tableData[i].operator_name = tableData[i].operator + '(' + tableData[i].operator_cn + ')'
          }
          this.totalCount = totalCount || 0
          // this.detailConfig[0]['label'] = '综合排名(' + this.totalCount + ')'
          tableData = tableData.map(item => {
            return {
              ...item,
              'cl_value': item.cl_value !== '--' ? Number(item.cl_value).toFixed(2) : item.cl_value,
              'xl_value': item.xl_value !== '--' ? Number(item.xl_value).toFixed(2) : item.xl_value,
              'zl_value': item.zl_value !== '--' ? `${Number(item.zl_value * 100).toFixed(2)}%` : item.zl_value,
              'hs_value': item.hs_value !== '--' ? Number(item.hs_value).toFixed(2) : item.hs_value,
              'sum_hs': item.sum_hs !== '--' ? Number(item.sum_hs).toFixed(2) : item.sum_hs,
              'hs_ratio': item.hs_ratio !== '--' ? `${Number(item.hs_ratio * 100).toFixed(2)}%` : item.hs_ratio,
            }
          })
          this.tableData = tableData
        }
      }
    },

    // 设置表格样式
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return 'warning-row'
      }
      return ''
    },

    handleSizeChange (val) {
      this.pageSize = val
      // console.log(`每页 ${val} 条`)
      this.queryParams['pageSize'] = this.pageSize
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // console.log(`当前页: ${val}`)
      this.queryParams['pageNo'] = this.currentPage
      this.getTableData()
    },

    // 根据当前是作业员还是内检员设置operator_type
    setDetailConfig (val) {
      if (val === 'zhizuo') {
        this.detailConfig = detailConfigs['gailanzuoye']
        this.operator_type = 'zhizuo'
        this.queryParams['operator_type'] = this.operator_type
      } else {
        this.detailConfig = detailConfigs['gailanneijian']
        this.operator_type = 'neijian'
        this.queryParams['operator_type'] = this.operator_type
      }
      // this.$forceUpdate()
      this.getTableData()
    },

    // 判断必须参数是否全部有值
    requiredParams () {
      if (this.queryParams['operator_type'] && this.queryParams['start_time'] && this.queryParams['end_time'] && this.queryParams['pageNo'] && this.queryParams['pageSize']) {
        return true
      } else {
        return false
      }
    },

    // 导出
    async exportDetail () {
      const paramsObj = {
        operator_type: this.queryParams['operator_type'],
        start_time: this.queryParams['start_time'],
        end_time: this.queryParams['end_time'],
        production_line: this.queryParams['production_line'],
        outsourcer: this.queryParams['outsourcer'],
        platform: this.queryParams['platform'],
        task_type: this.queryParams['task_type'],
        task_label: this.queryParams['task_label'],

      }
      const data = await gaiLanExport(paramsObj)
      downloadBlobFile(data)
    },

    // 链接到详情页时，得到当前人员的最后一个产线
    async getLastProducLine (row) {
      let operatorEn = row.split('(')[0]
      let paramsObj = {
        start_time: this.queryParams['start_time'],
        end_time: this.queryParams['end_time'],
        operator: operatorEn,
        operator_type: this.queryParams['operator_type'],
        platform: this.queryParams['platform'],
        task_type: this.queryParams['task_type'],
        task_label: this.queryParams['task_label'],
      }
      let res = {}
      if (!this.queryParams['production_line']) {
        res = await getProductLine(paramsObj)
      } else {
        res.production_line = this.queryParams['production_line']
      }
      if (JSON.stringify(res) !== '{}') {
        let { production_line: productionLine } = res
        let queryObj = {
          'operator': operatorEn,
          'production_line': productionLine,
          'start_time': this.queryParams['start_time'],
          'end_time': this.queryParams['end_time'],
          'platform': this.queryParams['platform'],
          'task_type': this.queryParams['task_type'],
          'task_label': this.queryParams['task_label'],
          'outsourcer': this.queryParams['outsourcer']
        }
        if (this.isIframe) {
          queryObj['iframe'] = '1'
        }
        this.$router.push({
          path: '/personnel-portrait/personnel-portrait-details',
          query: queryObj
        })
      }
    }
  },
  watch: {
    // 监听tab(内检员/作业员)是否变化
    tabName: function (val) {
      this.setDetailConfig(val)
    },
    // 监听是否点击查询，为四个参数赋值
    inquireNum: function (val) {
      this.queryParams['start_time'] = this.formData['start_time']
      this.queryParams['end_time'] = this.formData['end_time']
      this.queryParams['production_line'] = this.formData['production_line']
      this.queryParams['outsourcer'] = this.formData['outsourcer']
      this.currentPage = 1 // 重置页数
      this.getTableData()
    }
  }
}
</script>
<style>
body .el-table th {
  display: table-cell !important;
}
.table {
  /* position: relative;
  height: 100%; */
}
.table .el-table .has-gutter th {
    padding: 0;
  /* padding: 8px 0px; */
  background: rgba(246, 247, 251, 1);
  font-size: 14px;
}
.table .el-table .has-gutter th {
  height: 20px !important;
}
.table .el-table .has-gutter th .cell {
  height: 20px !important;
}
.table .el-table .el-table__row td {
  height: 40x;
  font-size: 12px;
  /* padding: 4px 0px; */
    padding: 0;
}
.table .el-table .warning-row {
  background: rgba(246, 247, 251, 1);
}

.table .el-table .warning-row {
  background: rgba(246,247,251,1);
}
.table .el-table__fixed-header-wrapper th{
    padding: 0;
  /* padding: 7px 0px 4px; */
  height: 20px!important;
  background: rgba(246,247,251,1);
  border-bottom: 1px solid rgba(246,247,251,1);
}
.table .cell .caret-wrapper {
  height: 20px;
}
.table .el-table .sort-caret.ascending {
  /* border-bottom-color: #c0c4cc; */
  top: -3px;
}
.table .el-table .sort-caret.descending {
  /* border-top-color: #c0c4cc; */
  bottom: -1px;
}
.table .pagination {
  /* position: absolute; */
  /* bottom: -40px; */
  /* right: 0px; */
  /* float:right */
   text-align: right;
}
.table  .content-title, .table span {
  height: 40px;
  font-size: 14px;
  font-weight: bold;
  color: rgba(7, 16, 49, 1);
  line-height: 40px;
}
</style>
